export default __webpack_public_path__ + "static/media/focusbtn.3c9d5180.svg";